import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Widget } from "react-typeform-embed";
import Header from "../components/header/clientHeader";
import ProfileDetails from "../components/profileDetails/profileDetails";
import Box from "@mui/material/Box";
import Login from "../components/loginModal/LoginModal";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Skeleton from "react-loading-skeleton";
import { Oval } from "react-loader-spinner";
import Avatar from "@mui/material/Avatar";
import moment from "moment";
import { Buffer } from "buffer";

// Import supabase configuration
import supabase from "../config/supabase";

import { useSelector, useDispatch } from "react-redux";

import MeetingDetail from "../components/meetingDetails/meetingDetail";


function MeetingDetials() {

  const navigate = useNavigate();


  
	const { clientNotification } = useSelector((state) => state.client);
	const { client_Profiles } = useSelector((state) => state.client);



  const [showNotification, setShowNotification] = useState(false);
  
  const [applyTransition, setApplyTransition] = useState(false);

  const [displayMessage, setDisplayMessage] = useState("");
  const [profile, setProfile] = useState([]);
  const [currentAgenda, setCurrentAgenda] = useState([]);
  const [previousAgenda, setPreviousAgenda] = useState([]);
  const [showCurrentAgenda, setShowCurrentAgenda] = useState(true);

  const [justView, setJustView] = useState(true);
  const [showLoader, setShowLoader] = useState(true);
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hideProfile, setHideProfile] = useState(false);
  const [showProfileDetail, setShowProfileDetail] = useState(false);
  const [toHomeUrl,setToHomeUrl] = useState("");
  const myRef = useRef(null);
  const executeScroll = () => myRef.current.scrollIntoView();

  useEffect( async() => {

    document.title = "Meeting Details Page";
    var url = new URL(window.location.href);

    var client_invitation_id = url.searchParams.get("id");
    client_invitation_id = Buffer.from(client_invitation_id || "", "base64").toString("utf-8");

      await getBoardProfiles(client_invitation_id);
      setShowLoader(false);
  }, []);


  useEffect(() => {
    
    var currentProfileId = localStorage.getItem('clientBoardProfile');
    var currentProfile = [];
    currentProfile = currentAgenda.filter(profile => profile.id ===currentProfileId);
    if(currentProfile.length === 0 && currentAgenda.length > 0){
      currentProfile.push(currentAgenda[0])
    }
    if(currentProfile.length === 0 && previousAgenda.length > 0){
      currentProfile = previousAgenda[0];
    }
    setProfile(currentProfile);

  }, [currentAgenda, previousAgenda]);


  useEffect(() => {
    setTimeout(() => {
      setApplyTransition(false);
      setHideProfile(false);
    }, 401);
  }, [applyTransition]);

  useEffect( () => {
    console.log(clientNotification);
    if(clientNotification.length> 0) {
      var meetings = clientNotification;
      meetings.map((m,index)=> {
        let date  = m.created_at && new Date(m.created_at);
        let newDate = date && new Date(date.getTime() - date.getTimezoneOffset()*60*1000);
        var end = newDate ? moment(newDate).format('h:mm A') : "";
        m.time = end;
        
        var today = new Date();
        var yesterday = new Date(today);
  
        yesterday.setDate(yesterday.getDate() - 1);
  
        var checkDay = new Date(today);
  
        checkDay.setDate(checkDay.getDate() - 6);
  
        if((date.getMonth() == today.getMonth()) && (date.getDate() == today.getDate())){
          m.day = "Today"
        }
        else if((date.getMonth() == yesterday.getMonth()) && (date.getDate() == yesterday.getDate())){
          m.day = "Yesterday"
        }
        else if((date.getMonth() >= checkDay.getMonth()) && (date.getDate() == checkDay.getDate())){
          var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
          var d =days[date.getDay()];
  
          m.day = d ;
        }
        else{
          m.day = moment(date).format('MMM Do');
        }
      })
      
      setNotifications(meetings);

    }
    
  },[clientNotification])

  useEffect( async() => {
    console.log(client_Profiles);
    if(client_Profiles.length > 0){
      
      var profiles =
      client_Profiles.length && client_Profiles[0].profiles
          ? await getAllProfiles(client_Profiles[0].profiles)
          : [];
      profiles.map(async (profile) =>{
        for(let index = 0; index < client_Profiles[0]?.profiles?.length; index++){
          // For logged in email user/ priavte user 
          if(profile.id == client_Profiles[0].profiles[index].id){

            if(client_Profiles[0].profiles[index].meetingTime){
              // Start meeting time
              let date  = new Date(client_Profiles[0].profiles[index].meetingTime);
              profile.meetingTime = moment(date).format('MMM D, h:mm A') ;
              
              var meetingDate = moment(date).format('dddd, MMMM D YYYY');
              meetingDate = meetingDate.split(' ');
              meetingDate[2] = meetingDate[2].concat("'");
              meetingDate = meetingDate.join(' ')
              profile.meetingDate = meetingDate;

              profile.fullMeetingTime = moment(date).format('ddd MMM D YYYY HH:mm:ss') ;

              // End meeting time
              let endDate  = client_Profiles[0].profiles[index].endMeetingTime && new Date(client_Profiles[0].profiles[index].endMeetingTime);
              profile.endMeetingTime = endDate ? moment(endDate).format('h:mm A') : "";
              profile.bgColor = client_Profiles[0].profiles[index].bgColor;
            }
            else{
              profile.meetingTime = client_Profiles[0].profiles[index].meetingTime;
              profile.endMeetingTime = client_Profiles[0].profiles[index].endMeetingTime;
              profile.bgColor = client_Profiles[0].profiles[index].bgColor;
            }
          }

          // Client hourly rate
          if(profile.id == client_Profiles[0].profiles[index].id){
            profile.client_hourly_rate = client_Profiles[0].profiles[index].rate;
        }
        }
      })

      var tempMeetingTimeArray = [];
      profiles.forEach((prof)=>{
      if(prof.meetingTime.length > 0){
          if(tempMeetingTimeArray?.findIndex((el) => el === prof.meetingTime) === -1){
            tempMeetingTimeArray.push(prof.meetingTime)
          }
        }
      })
      var sameAgendaProfiles = [];
      tempMeetingTimeArray.forEach( (el) => {
        var tempArray = [];
        tempArray = profiles.filter( (profile) => profile.meetingTime === el )
        sameAgendaProfiles.push(tempArray);
      })
      var previousAgendas = [];
        sameAgendaProfiles.forEach( (profiles) => {
          var date = new Date();
          var d =  moment(date).format('ddd MMM D YYYY HH:mm:ss');
          var res = moment(profiles[0].fullMeetingTime).isSameOrAfter(d);
          if(res){
            setCurrentAgenda(profiles);
          } else {
            previousAgendas.push(profiles);
          }
        })
      setPreviousAgenda(previousAgendas);
    }
    
  }, [client_Profiles])

  const getBoardProfiles = async (id) => {
    var client = [];

    // if (token) {
      var { data, error } = await supabase
        .from("board_clients_invitation")
        .select("*")
        .match({ id: id});

      if (data && data.length) {
        client = data;
        let homeUrl = data[0].url_with_token
        homeUrl = homeUrl.split("id")[1]
        setToHomeUrl(homeUrl)
        var { data, error } = await supabase
        .from("notifications")
        .select("*")
        .order('created_at', { ascending: false })
        .match({client: id});
        
        if(data && data.length){
          var meetings = data;
          meetings.map((m,index)=> {
            let date  = m.created_at && new Date(m.created_at);
            let newDate = date && new Date(date.getTime() - date.getTimezoneOffset()*60*1000);
            var end = newDate ? moment(newDate).format('h:mm A') : "";
            m.time = end;
           
            var today = new Date();
            var yesterday = new Date(today);

            yesterday.setDate(yesterday.getDate() - 1);

            var checkDay = new Date(today);

            checkDay.setDate(checkDay.getDate() - 6);

            if((date.getMonth() == today.getMonth()) && (date.getDate() == today.getDate())){
              m.day = "Today"
            }
            else if((date.getMonth() == yesterday.getMonth()) && (date.getDate() == yesterday.getDate())){
              m.day = "Yesterday"
            }
            else if((date.getMonth() >= checkDay.getMonth()) && (date.getDate() == checkDay.getDate())){
              var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
              var d =days[date.getDay()];
  
              m.day = d ;
            }
            else{
              m.day = moment(date).format('MMM Do');
            }
          })
         
          setNotifications(meetings);
        }
      }
    var sameAgendaProfiles = [];

    var profiles =
      client.length && client[0].profiles
        ? await getAllProfiles(client[0].profiles)
        : [];
        profiles.map(async (profile) =>{
          for(let index = 0; index < client[0]?.profiles?.length; index++){
            // For email user/ priavte user
            if(profile.id == client[0].profiles[index].id ){

              if(client[0].profiles[index].meetingTime){
                // Start meeting time
                let date  = new Date(client[0].profiles[index].meetingTime);
                profile.meetingTime = moment(date).format('MMM D, h:mm A');
                var meetingDate = moment(date).format('dddd, MMMM D YYYY');
                meetingDate = meetingDate.split(' ');
                meetingDate[2] = meetingDate[2].concat("'");
                meetingDate = meetingDate.join(' ')
                profile.meetingDate = meetingDate;
                
                profile.fullMeetingTime = moment(date).format('ddd MMM D YYYY HH:mm:ss');

                // End meeting time
                let endDate  = client[0].profiles[index].endMeetingTime && new Date(client[0].profiles[index].endMeetingTime);
                profile.endMeetingTime = endDate ? moment(endDate).format('h:mm A') : "";
                profile.bgColor = client[0].profiles[index].bgColor;
              }
              else{
                profile.meetingTime = client[0].profiles[index].meetingTime;
                profile.endMeetingTime = client[0].profiles[index].endMeetingTime;
                profile.bgColor = client[0].profiles[index].bgColor;

              }
            }

            // Client hourly rate
            if(profile.id == client[0].profiles[index].id){
                profile.client_hourly_rate = client[0].profiles[index].rate;
                profile.paymentFrequency = client[0].profiles[index].paymentFrequency;
            }
          }
        })
      var tempMeetingTimeArray = [];
      profiles.forEach((prof)=>{
      if(prof.meetingTime.length > 0){
          if(tempMeetingTimeArray?.findIndex((el) => el === prof.meetingTime) === -1){
            tempMeetingTimeArray.push(prof.meetingTime)
          }
        }
      })
      var sameAgendaProfiles = [];
      tempMeetingTimeArray.forEach( (el) => {
        var tempArray = [];
        tempArray = profiles.filter( (profile) => profile.meetingTime === el )
        sameAgendaProfiles.push(tempArray);
      })
      var previousAgendas = [];
        sameAgendaProfiles.forEach( (profiles) => {
          var date = new Date();
          var d =  moment(date).format('ddd MMM D YYYY HH:mm:ss');
          var res = moment(profiles[0].fullMeetingTime).isSameOrAfter(d);
          if(res){
            setCurrentAgenda(profiles);
          } else {
            previousAgendas.push(profiles);
          }
        })
    setPreviousAgenda(previousAgendas);
    setShowLoader(false);
    setLoading(false);
  };

  const getAllProfiles = async (ids) => {
    var allIds = [];
    var all_profiles = [];
    ids.forEach( (id) => {
      allIds.push(id.id);
    })
      const { data, error } = await supabase
      .from("all_profiles")
      .select("*")
      .in('id', allIds);

      if(data && data.length > 0) {
        ids.forEach( (val,index) => {
          data.forEach((profileValue, i) => {
            if(val.id == profileValue.id){
            var profile = { ...data[i],paymentFrequency: ids[index].paymentFrequency, status: ids[index].status, meetingTime: ids[index].meetingTime, cancelUrl: ids[index].cancel_url ? ids[index].cancel_url : '', rescheduleUrl: ids[index].reschedule_url ? ids[index].reschedule_url : '', event_uuid: ids[index].event_uuid ? ids[index].event_uuid : '' ,
            meetingUrl: ids[index].meetingUrl ? ids[index].meetingUrl : '' };
            all_profiles.push(profile);
            }
          })
          // }
        })
        return all_profiles
      } else {
        console.log('no profiles');
      }
  };

  const getProfileDetails = (id) => {
    var singleProfile = currentAgenda.filter((index) => index.id == id)
    if(singleProfile.length === 0){
      previousAgenda.forEach( (agenda) => {
        if(singleProfile.length === 0){
          singleProfile = agenda.filter((index) => index.id == id);
        }
      })
    }
    setProfile(singleProfile);
    setShowProfileDetail(true);
    setApplyTransition(!applyTransition);
  };

  const toReschedule = () => {
    if(currentAgenda[0].rescheduleUrl){
      var url = new URL(window.location.href);
  
      var client_invitation_id = url.searchParams.get("id");
  
      navigate(`/interviewReSchedule?client=${client_invitation_id}&calendlyUrl=${Buffer.from(currentAgenda[0].rescheduleUrl, "utf-8").toString("base64")}`)
    } else {
      setDisplayMessage('A meeting can be rescheduled only once');
      setShowNotification(true);
    }
  }
  

  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={() => setShowNotification(false)}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  return (
    <div>
      <Header justView={!justView} showLogin={localStorage.getItem("supabase.auth.token") ? false : true} toHomeUrl={toHomeUrl}  notifications={notifications} >       
         {/* {showLoader && (
          <div className="fixed flex items-center justify-center z-10 w-full h-full top-0 bg-white-1">
            {/* Add backdrop */}
            {/*
            <div className={`relative flex`}>
              <Oval
                  color="white"
                  secondaryColor="grey"
                  height="40"
                  width="60"
                />
                <div className="flex items-center">Hold Tight-just getting this page ready.</div>
            </div>
          </div>
        )}  */}

        {/* Notification */}
        <Snackbar
          open={showNotification}
          message={displayMessage}
          onClose={() => setShowNotification(false)}
          autoHideDuration={2000}
          action={action}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        />

        {/* Add div */}
        <div className={`bg-white-6 col-span-12 grid grid-cols-12 gap-0 ${showLoader ? "md:h-screen":"md:h-full"} h-screen`}>
          
          {/* Div for the card */}
          {showLoader ?
           <div className="rounded bg-white-1 col-span-12 md:col-span-6 grid grid-cols-12 h-60 gap-3 p-4 box-border mx-4 my-5 mb-4" >
              <div className="col-span-10 mt-2">
                <Skeleton height={20} width={300} />
                <div className="grid grid-cols-12 gap-6">
                  <div className="mt-6 col-span-6">
                    <Skeleton height={14} width={60} />
                  </div>
                  <div className="mt-6 col-span-6">
                    <Skeleton height={14} width={60} />
                  </div>
                </div>
                <div className="mt-2 grid grid-cols-12 gap-6">
                  <div className="col-span-6 mt-2">
                    <Skeleton height={16} width={128} />
                  </div>
                  <div className="col-span-6 mt-2">
                    <Skeleton height={16} width={128} />
                  </div>
                </div>

                <div className="grid grid-col-12 mt-2">
                  <div>
                    <Skeleton height={28} width={300} />
                  </div>
                </div>
                {/*icons*/}
                <div className="visible md:hidden col-span-12 mt-2 pb-2">
                  <Skeleton height={40} width={190} />
                </div>
              </div>
              <div className="invisible md:visible col-span-2 pl-5">
                {/*icons*/}
                <div className="col-span-12">
                  <Skeleton height={190} width={50} />
                </div>
              </div>
            </div>
            :
            <div className="col-span-12 md:col-span-6">
                <div className="flex my-5 mx-3 relative ml-5 justify-between md:justify-start md:pr-0 pr-4">
                  <div className={` ${showCurrentAgenda ? "md:text-[26px] text-[16px] font-semibold":"text-base"} cursor-pointer`} onClick={() => setShowCurrentAgenda(true)}>Scheduled Meetings</div>
                  <div className={`cursor-pointer ${!showCurrentAgenda ? "md:text-[26px] text-[16px] -top-2 md:left-44 font-semibold":"text-base bottom-1 md:left-72"} md:absolute `}  onClick={() => setShowCurrentAgenda(false)}>Previous Meetings</div>
                </div>
                {showCurrentAgenda ? 
                  currentAgenda?.length > 0 ? <MeetingDetail toReschedule={toReschedule} currentProfile={profile[0]} agenda={currentAgenda} getId = { (id) => getProfileDetails(id)} /> :
                  <div className="bg-white-1 m-4 p-4 text-center rounded border-t-4 border-blue-10">No Current Agenda</div>
                  :
                  previousAgenda?.length > 0 ? 
                  previousAgenda.map((agenda) => (
                  <MeetingDetail previous={true} currentProfile={profile[0]} agenda={agenda} getId = { (id) => getProfileDetails(id)} />
                   )) :
                  <div className="bg-white-1 m-4 p-4 text-center rounded border-t-4 border-blue-10">No Previous Agenda</div>

                }
            </div>
            }
          {/* Show text */}
          <div className="hidden md:block md:col-span-6">
            {
              showLoader ? (
                <Skeleton height={"100%"} width={"100%"} />
              ):(
                <>
                {profile?.length && <ProfileDetails applyTransition={applyTransition} hideProfile={hideProfile} loading={loading} showLogin={localStorage.getItem("supabase.auth.token") ? false : true} profile={profile[0]} myRef={myRef}  meetingDetailPage={true} /> }
                </>
              )
            }
          </div>
        </div>
      </Header>
    </div>
  );
}

export default MeetingDetials;
